import React, { useEffect } from "react";
import svg7 from "../../../../assets/svg/svg7.svg";
import svg33 from "../../../../assets/svg/svg33.svg";
import { Descriptions, Divider, Progress } from "antd";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ProjectProgressCard from "./ProjectProgressCard";
import ReportsByDateTable from "./ReportsByDateTable";
import BreadCrumb from "../../../../layout/BreadCrumb";
import moment from "moment";
import { fetchData } from "../../../../features/fetch/fetchSlice";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import customParseFormat from "dayjs/plugin/customParseFormat";

function ProjectProgressDetailList() {
  const url = "project/fetch_projects";
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { activeObjMontProj, data } = useSelector((state) => ({
    activeObjMontProj: state.obj.activeObj["montProj"],
    data: state.fetch.data[url] || [],
  }));

  dayjs.extend(relativeTime);

  const today = dayjs();
  const projectEndDateStr = data?.[0]?.projStartDate;
  const projectEndDate = dayjs(projectEndDateStr);
  const diffText = projectEndDate?.isValid()
    ? projectEndDate?.from(today)
    : "Invalid Date";

  const items1 = [
    {
      key: "1",
      label: "Start Date",
      children: (
        <div>
          {data?.[0]?.projStartDate
            ? moment(data?.[0]?.projStartDate)?.format("DD-MM-YYYY")
            : "--"}
        </div>
      ),
    },
    {
      key: "5",
      label: "Expected End Date",
      children: (
        <div>
          {data?.[0]?.projectEndDate
            ? moment(data?.[0]?.projectEndDate)?.format("DD-MM-YYYY")
            : "--"}
        </div>
      ),
    },
    {
      key: "2",
      label: "Time Elapsed",
      children: <div>{diffText}</div>,
    },
  ];
  async function fetchTableData() {
    await dispatch(
      fetchData({
        url: url,
        limit: null,
        start: 0,
        projProjectId: activeObjMontProj?.projectId,
      })
    );
  }

  useEffect(() => {
    fetchTableData();
  }, []); 
  return (
    <>
      <BreadCrumb
        breadcrumbs={[
          { title: "Project Progress", path: "/rob/project-progress" },
          { title: `Progress Details ${data?.[0]?.projectName}` },
        ]}
      />
      <div className="white_card mt-[2.41rem]">
        <div className="text-[#0092CC] font-interSans font-[500] text-[.75rem]">
          {data?.[0]?.projNumber}
        </div>
        <div className="form-add-h !text-[#050505] mt-[.63rem]">
          {data?.[0]?.projName}
        </div>
        <div className="proj_desc mt-[.62rem]">{data?.[0]?.projectRemarks}</div>
        <div className="mt-[1.25rem] flex lg:flex-row flex-col gap-y-2 lg:items-center gap-x-[.62rem] w-full">
          <div className="flex items-center gap-x-1">
            <img src={svg7} alt="svg7" />
            <span className="forgot-text">{data?.[0]?.projectCountyName}</span>
          </div>

          <div className="flex items-center gap-x-1 ">
            <img src={svg33} alt="svg33" />
            <span className="forgot-text"> {data?.[0]?.projectAgencyName}</span>
          </div>

          <div className="flex  items-center flex-1 gap-x-[.62rem]">
            <span className="forgot-text lg:flex hidden">| Progress</span>
            <Progress
              strokeColor="#4FAD5B"
              className="lg:w-[30%] w-full"
              percent={data?.[0]?.projectCompletionRate}
            />
          </div>
        </div>

        <div className="flex items-center lg:flex-row flex-col mt-[2.5rem] w-full">
          <div className="w-full">
            <Descriptions column={1} colon={false} items={items1} />
          </div>

          <div className="w-full">
            <ProjectProgressCard />
          </div>
        </div>

        <div className="mt-[2.44rem]">
          <Divider />
        </div>
        <ReportsByDateTable />
      </div>
    </>
  );
}

export default ProjectProgressDetailList;
